
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/best-ai-powered-motion-capture-tools",
      function () {
        return require("private-next-pages/blog/best-ai-powered-motion-capture-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/best-ai-powered-motion-capture-tools"])
      });
    }
  